/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Group_Images_EmptyInputs */

const vi_shop_group_images_empty = /** @type {(inputs: Shop_Group_Images_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có loại nào. Thêm loại để thấy ảnh.`)
};

/**

* @param {Shop_Group_Images_EmptyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_group_images_empty = /** @type {((inputs?: Shop_Group_Images_EmptyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Group_Images_EmptyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_group_images_empty(inputs)
});